import { tns } from "tiny-slider/src/tiny-slider";
import "jquery.marquee";
import LazyLoad from "vanilla-lazyload";
var lazyLoad = new LazyLoad();

export default function init() {
  // access button link Orange confort
  jQuery(".header__flash-infos .ticker").marquee({
    // duration: 10000,
    speed: 80,
    gap: 30,
    delayBeforeStart: 0,
    direction: "left",
    duplicated: true,
    pauseOnHover: true,
    startVisible: false,
  });

  function sliderLazy() {
    lazyLoad.update();
  }

  // Init slider pour .slider-publications
  var sliderPublications = tns({
    container: ".slider-publications",
    items: 1,
    autoplay: false,
    nav: false,
    controls: true,
    controlsContainer: ".controls-slider-publications",
  });

  sliderPublications.events.on("indexChanged", sliderLazy);
}
